export type { ProductAssessmentWidgetProps } from "./product-assessment-widget";
export { ProductAssessmentWidget } from "./product-assessment-widget";
